<template>
    <div class="table-container exp-note-table">
        <div class="exp-textarea-style text-area-block">
            <div class="box">
                <span class="enf-placeholder">{{ mdItem.name }}</span>
                <template v-if="!reading">
                    <i class="tas-action icon icon-pencil-edit"
                       @click="editDescription(!reading)">
                    </i>
                </template>
                <template v-else>
                    <i class="tas-action icon icon-eye-open"
                       @click="editDescription(reading)">
                    </i>
                </template>
            </div>
        </div>
        <b-modal
            v-model="modalVisible"
            modal-class="enf-modal"
            size="lg"
            centered
            :title="mdTitle"
            hide-footer>
            <b-form-group :disabled="reading">
                <template #label>{{  trMsg(MSG_CARD_SEC + '1.ru') }}</template>
                <template v-if="!reading">
                    <b-form-textarea
                        style="text-align: justify"
                        :placeholder="trMsg(MSG_CARD_SEC + '1.fill_in')"
                        v-model="mdItem.name_ru">
                    </b-form-textarea>
                </template>
                <template v-else>
                    <b-form-textarea
                        style="text-align: justify"
                        readonly
                        v-model="mdItem.name_ru">
                    </b-form-textarea>
                </template>
            </b-form-group>

            <b-form-group :disabled="reading">
                <template #label>{{ trMsg(MSG_CARD_SEC + '1.kk') }}</template>
                <template v-if="true">
                    <b-form-textarea
                        :placeholder="trMsg(MSG_CARD_SEC + '1.fill_in')"
                                     v-model="mdItem.name_kk"
                                     style="text-align: justify"></b-form-textarea>
                </template>
                <template v-else>
                    <b-form-textarea readonly
                                     v-model="mdItem.name_kk"
                                     style="text-align: justify"></b-form-textarea>
                </template>
            </b-form-group>

            <template v-if="!reading">
                <b-button variant="primary" @click="addDescriptionForm">
                    {{ trMsg(MSG_BIP + 'btn.save') }}
                </b-button>
            </template>
            <b-button variant="light" @click="modalVisible = false">
                {{ trMsg(MSG_BIP + 'btn.cancel') }}
            </b-button>
        </b-modal>
    </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import {itemNameLocale, locale, MSG_BIP, MSG_CARD_SEC, trMsg} from "@/modules/budget/bip/bip-types";

export default {
    name: 'NameLg',
    props: {
        reading: null,
        mdTitle: null,
        item: null,
        field_ru: null,
        field_kk: null
    },
    data() {
        return {
            MSG_BIP: MSG_BIP,
            MSG_CARD_SEC: MSG_CARD_SEC,

            modalVisible: false,
            mdItem: {}
        }
    },

    async created() {
        this.$watch('item', (value) => {
            this.$set(this.mdItem, 'name_ru', value[this.field_ru]);
            this.$set(this.mdItem, 'name_kk', value[this.field_kk]);
            this.$set(this.mdItem, 'name_en', value[this.field_ru]);
            itemNameLocale(this.mdItem);
        });
    },

    methods: {
        addDescriptionForm() {
            this.$emit('changeNames', this.mdItem);
            this.modalVisible = false;
        },

        editDescription(show) {
            this.modalVisible = show;
        },

        // translate messages
        trMsg(field) {
            return trMsg(this, field);
        }
    }
};
</script>